export const isCasinoPage = (): boolean => {
    const {pathname} = window.location;

    return Boolean(pathname.match('[\\/]casino($|[\\/])'));
};
